import React from "react";
import { CardContainer2 } from "./Cards";

import imageToby from "../assets/TP_LNSG_Website.jpg"
import imagePierre from "../assets/PM_LNSG_Website.jpg"
import imageDaniel from "../assets/DK_LNSG_Website.jpg"

interface Props {
}


function shuffle(a: any[]) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
}

const ourCandidates = [
    {
        imageUrl: imagePierre,
        title: "Pierre Masse",
        title2: "for Lane Cove",
        buttons: [{
            text: "Click here to read more about Pierre",
            url: "https://greens.org.au/nsw/person/pierre-masse",
        }],
    },
    {
        imageUrl: imageToby,
        title: "Toby Pettigrew",
        title2: "for North Shore",
        buttons: [{
            text: "Click here to read more about Toby",
            url: "https://greens.org.au/nsw/person/toby-pettigrew",
        }],
        facebookUrl: "https://www.facebook.com/TobyP.Greens/",
    },
    {
        imageUrl: imageDaniel,
        title: "Daniel Keogh",
        title2: "for Willoughby",
        buttons: [{
            text: "Click here to read more about Daniel",
            url: "https://greens.org.au/nsw/person/daniel-keogh",
        }],
        facebookUrl: "https://www.facebook.com/DKGreens/",
    },
]

export function OurCandidates(props: Props) {

    return (
        <>
            <CardContainer2 imageHeight="420px" cards={ourCandidates} />

            <CardContainer2
                imageHeight="420px"
                cards={[
                    {
                        imageUrl: "https://greens.org.au/sites/default/files/styles/action_box/public/2018-12/mehreeen-faruqi.jpg",
                        title: "Mehreen Faruqi",
                        title2: "for NSW (Federal)",
                        buttons: [{
                            text: "Click here to read more about Mehreen",
                            url: "https://greens.org.au/nsw/person/mehreen-faruqi",
                        }],
                    },
                    {
                        imageUrl: "https://greens.org.au/sites/default/files/styles/action_box/public/2018-05/david-profile-v0.1.png",
                        title: "David Shoebridge",
                        title2: "for NSW",
                        title3: "(State)",
                        titleNegativeMargin: "-0.5em",
                        buttons: [{
                            text: "Click here to read more about David",
                            url: "https://greens.org.au/nsw/person/david-shoebridge",
                        }],
                    },
                    {
                        imageUrl: "https://greens.org.au/sites/default/files/styles/action_box/public/2018-11/Abigail-outdoors-768x1027.jpg",
                        title: "Abigail Boyd",
                        title2: "for NSW",
                        title3: "(State)",
                        buttons: [{
                            text: "Click here to read more about Abigail",
                            url: "https://greens.org.au/nsw/person/abigail-boyd",
                        }],
                    },
                    {
                        imageUrl: "https://greens.org.au/sites/default/files/styles/action_box/public/2018-05/dawn-profile-v0.1-comp.png",
                        title: "Dawn Walker",
                        title2: "for NSW",
                        title3: "(State)",
                        buttons: [{
                            text: "Click here to read more about Dawn",
                            url: "https://greens.org.au/nsw/person/dawn-walker",
                        }],
                    },
                ]}
            />
        </>
    )
}